"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var paymentTypes = [{
  flag: '',
  title: 'Basic',
  annual: {
    description: '$16.67/month',
    subdescription: '$200/year billed annually',
    price: 200
  },
  monthly: {
    description: '$20/month',
    price: 20
  },
  listOfQualities: ['Basic SEO, to help customers find you', 'Mobile Optimized Design', 'Free Domain', 'Dashboard, to make site edits directly', 'SSL, to keep your website secure']
}, {
  flag: 'MOST POPULAR',
  title: 'Premium',
  annual: {
    description: '$41.67/month',
    subdescription: '$500/year billed annually',
    price: 500
  },
  monthly: {
    description: '$50/month',
    price: 50
  },
  listOfQualities: ['Everything in Basic, Plus:', 'Advanced SEO', 'Multiple Locations', 'Phone Support']
}, {
  flag: '',
  title: 'Advanced',
  annual: {
    description: 'Custom',
    subdescription: ''
  },
  monthly: {
    description: 'Custom'
  },
  listOfQualities: ['Everything in Premium, Plus:', 'Customized Design', 'HD Photography', 'Special Features Request']
}];
var _default = paymentTypes;
exports["default"] = _default;